const fillColor = "#80d8ff";
const strokeColor = "#00b0ff";

const defaultOpts = {
  strokeColor: strokeColor,
  strokeWeight: 1,
  strokeOpacity: 1,
  fillOpacity: 0.6,
  draggable: false,
  fillColor
};

const PRICE_MAP = [
  {
    strokeColor: "",
    fillColor: "#bae7ff"
  },
  {
    strokeColor: "",
    fillColor: "#91d5ff"
  },
  {
    strokeColor: "",
    fillColor: "#69c0ff"
  },
  {
    strokeColor: "",
    fillColor: "#40a9ff"
  },
  {
    strokeColor: "",
    fillColor: "#1890ff"
  },
  {
    strokeColor: "",
    fillColor: "#f5222d"
  },
  {
    strokeColor: "",
    fillColor: "#cf1322"
  },
  {
    strokeColor: "",
    fillColor: "#820014"
  }
];

export default class MapUtil {
  static overlay2Json(data) {
    const detail = {};
    detail.type = data.CLASS_NAME;
    if (data.getPath) {
      // 构造成后台存储需要的结构
      const path = data.getPath().map((item) => {
        return {
          lat: item.lat,
          lng: item.lng
        };
      });
      detail.options = {
        path
      };
    }
    return detail;
  }

  static overlay2Points(data) {
    // 构造成后台存储需要的结构
    const path = data.getPath().map((item) => {
      return {
        x: item.lat,
        y: item.lng
      };
    });

    return path;
  }

  static json2Overlay(item, colorInfo = PRICE_MAP[0]) {
    const options = MapUtil.getOverlayDefaultOpts(item, colorInfo);
    return new AMap.Polygon(options);
  }

  static getOverlayDefaultOpts(item, colorInfo) {
    const path = item.areaPoints.map((t) => {
      return [t.y, t.x];
    });

    const mergeOpts = {
      ...defaultOpts,
      ...colorInfo,
      path,
      extData: {
        yxId: item.id,
        originData: item
      }
    };

    return mergeOpts;
  }

  static getNearestPoint(currentPoint, points) {
    let minDistance = Number.MAX_VALUE;
    let nearestPoint = null;

    points.forEach((point) => {
      const distance = MapUtil.getLineDistance(point, currentPoint);
      if (distance < minDistance) {
        minDistance = distance;
        nearestPoint = point;
      }
    });

    return nearestPoint;
  }

  static getLineDistanceByLatLng(lat1, lng1, lat2, lng2) {
    const rad = (d) => (d * Math.PI) / 180;
    const EARTH_RADIUS = 6378.137;
    const radLat1 = rad(Number(lat1));
    const radLat2 = rad(Number(lat2));
    const a = radLat1 - radLat2;
    const b = rad(Number(lng1)) - rad(Number(lng2));
    let s =
      2 *
      Math.asin(
        Math.sqrt(
          Math.pow(Math.sin(a / 2), 2) +
            Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)
        )
      );
    s = s * EARTH_RADIUS * 1000;
    return Math.round(s);
  }

  static getLineDistance(p1, p2) {
    return MapUtil.getLineDistanceByLatLng(p1.lat, p1.lng, p2.lat, p2.lng);
  }

  /** areaPoints 中 x=纬度、y=经度，返回推荐点到区域边界最近点 */
  static getClosestPointOnPolygonBoundary(lat, lng, areaPoints) {
    if (!areaPoints || !areaPoints.length) {
      return null;
    }
    let minDistance = Number.MAX_VALUE;
    let closest = null;
    const size = areaPoints.length;
    for (let i = 0; i < size; i++) {
      const start = areaPoints[i];
      const end = areaPoints[(i + 1) % size];
      const segClosest = MapUtil.getClosestPointOnSegment(lat, lng, start.x, start.y, end.x, end.y);
      const dist = MapUtil.getLineDistanceByLatLng(lat, lng, segClosest.lat, segClosest.lng);
      if (dist < minDistance) {
        minDistance = dist;
        closest = segClosest;
      }
    }
    return closest;
  }

  static getClosestPointOnSegment(lat, lng, lat1, lng1, lat2, lng2) {
    const x0 = Number(lat);
    const y0 = Number(lng);
    const x1 = Number(lat1);
    const y1 = Number(lng1);
    const x2 = Number(lat2);
    const y2 = Number(lng2);
    const dx = x2 - x1;
    const dy = y2 - y1;
    const lenSq = dx * dx + dy * dy;
    let closestLat;
    let closestLng;
    if (lenSq === 0) {
      closestLat = x1;
      closestLng = y1;
    } else {
      const param = ((x0 - x1) * dx + (y0 - y1) * dy) / lenSq;
      if (param < 0) {
        closestLat = x1;
        closestLng = y1;
      } else if (param > 1) {
        closestLat = x2;
        closestLng = y2;
      } else {
        closestLat = x1 + param * dx;
        closestLng = y1 + param * dy;
      }
    }
    return { lat: closestLat, lng: closestLng };
  }
}
